import axios, { AxiosError } from 'axios';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store/store';
import React from 'react';

type PropsFormUser = {
  dataUser: any;
};

export const CheckOutView = (props: PropsFormUser) => {


  const downloadContract = () => {
    axios
      .get(
        `${process.env.REACT_APP_API_BACKEND}/docusign/download/${localStorage.getItem('register_id')}`,
        {
          responseType: 'blob', // Set the response type to 'blob' for binary data
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token_user_latam')}`
          }
        }
      )
      .then((response: any) => {
        // Create a Blob URL and open it in a new window or initiate download
        const url = URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
        //    window.open(url, '_blank'); // Open in a new window

        //   Para descargar
        const a = document.createElement('a');
        a.href = url;
        a.download = 'contract.pdf';
        a.click();
      })
      .catch((error: AxiosError) =>
        console.error('Error Docusign Firma =>', error)
      );
  };

  return (
    <section className="w-full max-w-6xl mx-auto ">


      <div className="bg-white border border-gray-300 rounded-lg shadow-sm mb-6">
        <div className="p-8 text-center border-b border-gray-300 bg-gradient-to-br from-sky-50 to-white">
          <h3 className="text-2xl md:text-3xl font-semibold text-gray-900 mb-3">
            ¡Felicidades, {props.dataUser.user.name}!
          </h3>
          <p className="text-gray-700 max-w-2xl mx-auto">
            Has finalizado tu proceso administrativo, por lo que ya eres parte de la Academia de Talentos Digitales <strong>Desafío Latam</strong>
          </p>
        </div>
        <div className="p-6 md:p-8">
          <div className="bg-gray-50 border border-gray-200 rounded-lg p-6 mb-6">
            <div className="flex items-center gap-4 mb-6">
              <div className="flex items-center justify-center h-16 w-16 rounded-full bg-sky-600 text-white flex-shrink-0">
                <span className="text-2xl font-bold">
                  {props.dataUser.user.name.charAt(0)}{props.dataUser.user.lastname.charAt(0)}
                </span>
              </div>
              <div>
                <h4 className="font-semibold text-xl text-gray-900">
                  {props.dataUser.user.name} {props.dataUser.user.lastname}
                </h4>
                <p className="text-gray-600">{props.dataUser.user.email}</p>
              </div>
            </div>

            <div className="grid gap-4 md:grid-cols-2">
              <div>
                <h5 className="font-semibold text-gray-900 mb-2">Programa:</h5>
                <p className="text-gray-700">
                  {props.dataUser.variant_application == 1
                    ? props.dataUser.career.variant_friendly_name
                    : props.dataUser.career.friendly_name}
                </p>
              </div>
              <div>
                <h5 className="font-semibold text-gray-900 mb-2">Detalle del pago:</h5>
                <p className="text-gray-700">
                  {props.dataUser.purchase.payment_method.description} - {props.dataUser.purchase.supplier}
                </p>
              </div>
            </div>

            {props.dataUser.form_type_id != 2 && (
              <div className="mt-6 pt-6 border-t border-gray-200">
                <button
                  className="inline-flex items-center text-sky-600 hover:text-sky-700 font-medium transition-colors"
                  onClick={downloadContract}
                >
                  <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                  </svg>
                  Descarga tu contrato
                </button>
              </div>
            )}
          </div>
          <div className="bg-sky-50 border border-sky-200 rounded-lg p-6 mb-6">
            <div className="flex items-start gap-3">
              <svg className="w-6 h-6 text-sky-600 flex-shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              <p className="text-gray-700">
                Tus accesos a las plataformas de aprendizaje serán enviados a tu e-mail el viernes anterior al inicio de clases.
              </p>
            </div>
          </div>
          <div className="text-center py-6">
            <p className="text-gray-700 mb-2">Felicidades por aceptar el desafío, ahora</p>
            <p className="text-2xl font-bold text-green-600">¡Vamos con todo!</p>
          </div>
        </div>
      </div>

    </section>
  );
};
